// extracted by mini-css-extract-plugin
export default {"search_container":"Search_search_container__822td"};